import { render, staticRenderFns } from "./pogs-form__item--obprocedure.vue?vue&type=template&id=2f8d382c&scoped=true&"
import script from "./pogs-form__item--obprocedure.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--obprocedure.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form__item--obprocedure.vue?vue&type=style&index=0&id=2f8d382c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d382c",
  null
  
)

export default component.exports